import React from "react";

function NormalText(props) {
  const { children, className, useParag, ...otherProps } = props;

  if (useParag) {
    return (
      <p className={`font-normal ${className ?? ""}`} {...otherProps}>
        {children}
      </p>
    );
  }

  return (
    <span className={`font-normal ${className ?? ""}`} {...otherProps}>
      {children}
    </span>
  );
}

export default NormalText;
